/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import api from '~/services/api';
import { addModuloID } from '~/store/modules/Modulos/actions';
import { Container } from '~/styles/pagesStyle';
import { handleDeleteModulo, handleUpdateModulo } from '../ModulosServices';
import UpdateCard from './UpdateCard';

const initialForm = {
  nome: '',
  situacaoCadastral: '',
  cor: '',
  classe: '',
  ordem: '',
};

function ModuloUpdate() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [moduleData, setModuleData] = useState({});
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(initialForm);

  const usuario = sessionStorage.getItem('@auth/userName');

  useEffect(() => {
    setLoading(true);
    async function getData() {
      dispatch(addModuloID(id));
      await api
        .get(`/Modulo/${id}`)
        .then((response) => {
          setModuleData(response.data);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Erro ao buscar dados do módulo');
          setLoading(false);
          history.push('/module/list');
        });
    }
    getData();
  }, [history, id]);

  async function handleUpdate(e) {
    const modulo = {
      id,
      nome: form.nome || moduleData.nome,
      idsituacaoCadastral:
        form.situacaoCadastral || moduleData.idSituacaoCadastral,
      cor: form.cor || moduleData.cor,
      classeCss: form.classe || moduleData.classeCss,
      ordem: form.ordem || moduleData.ordem,
      dataInclusao: null,
      usuario,
      excluido: false,
    };
    e.preventDefault();
    setLoading(true);
    await handleUpdateModulo(setLoading, modulo);
    history.push('/modulo/list');
  }

  return (
    <Container>
      <Footer />
      <Menu />
      {Object.keys(moduleData).length <= 0 ? (
        <Spinner
          color="dark"
          style={{ width: '3rem', height: '3rem', margin: '5% auto' }}
        />
      ) : (
        <UpdateCard
          moduloData={moduleData}
          setForm={setForm}
          form={form}
          handleUpdate={handleUpdate}
          loading={loading}
          setLoading={setLoading}
          id={id}
        />
      )}
    </Container>
  );
}

export default ModuloUpdate;
